import React, { Component } from 'react';
import { connect } from 'react-redux';
import AWS from 'aws-sdk';
import moment from 'moment';
import PropTypes from 'prop-types';
import './AdvancedDocumentsTable.css';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faFolder from '@fortawesome/fontawesome-free-solid/faFolder';
import CreateFolderModal from './CreateFolderModal';
import UploadFilesModal from './UploadFilesModal';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import DownloadObjectsModal from './DownloadObjectsModal';
import {
  createAdvancedDocumentsFolderRequest,
  renameAdvancedDocumentsFolderRequest,
  uploadAdvancedDocumentsRequest,
  deleteAdvancedDocumentsRequest,
  downloadAdvancedDocumentsFolderRequest,
  moveAdvancedDocumentsFolderRequest,
} from 'components/admin/projects/details/project-documentation/store/actions';
import { usersUtil, TYPES } from 'services/utils/users-util';
import { getCurrentUser } from 'selectors/authentication';
import { getCurrentProject } from 'components/admin/projects/details/store/selectors';
import Dropdown from 'components/shared/dropdown/Dropdown';
import MoveFolderOrFileModal from './MoveFolderOrFileModal';
import SimpleHeader from 'components/shared/table/SimpleHeader';

AWS.config.region = 'us-east-1';

const s3 = new AWS.S3();
class AdvancedDocumentsTable extends Component {
  static propTypes = {
    bucket: PropTypes.string.isRequired,
    prefix: PropTypes.string.isRequired,
    region: PropTypes.string.isRequired,
    delimiter: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      files: [],
      prefix: this.props.prefix,
      showCreateFolderModal: false,
      currentFolderName: null,
      showUploadFilesModal: false,
      renameFolder: false,
      selectAll: false,
      showDeleteFilesConfirmation: false,
      showDownloadObjectsModal: false,
      showMoveFolderModal: false,
      moveObjectSelected: null,
      showEmailObjectsModal: false,
      filesHeaderStatus: null,
      filesSortDirection: 'ascending',
    };
  }

  componentDidMount = () => {
    this.renderDocuments();
  };

  renderDocuments = () => {
    this.fetchFiles();
  };

  retrieveFolder = (event, prefix) => {
    event.preventDefault();
    this.setState(
      {
        prefix,
      },
      () => {
        this.renderDocuments();
      }
    );
  };

  bytesToSize = (bytes) => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Bytes';

    const ii = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    return `${Math.round(bytes / 1024 ** ii, 2)} ${sizes[ii]}`;
  };

  htmlEscape = (str) => {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/\//g, '&#x2F;')
      .replace(/`/g, '&#x60;')
      .replace(/=/g, '&#x3D;');
  };

  isFolder = (path) => {
    return path.endsWith('/');
  };

  isThisDocument = (key) => {
    return key === 'index.html';
  };

  getPath = (file) => {
    return file.Key ? file.Key : file.Prefix;
  };

  fullPathToFileName = (path) => {
    return this.htmlEscape(path.replace(/^.*[\\/]/, ''));
  };

  fullPathToFolder = (prefix, escape = false) => {
    const parts = prefix.split('/');
    const rc = `${parts[parts.length - 2]}/`;
    return escape ? this.htmlEscape(rc) : rc;
  };

  fileS3Path = (key) => {
    var enckey = key
      .split('/')
      .map(function (x) {
        return encodeURIComponent(x);
      })
      .join('/');

    if (AWS.config.region === 'us-east-1') {
      return (
        document.location.protocol +
        '//' +
        this.props.bucket +
        '.s3.amazonaws.com/' +
        enckey
      );
    } else {
      return (
        document.location.protocol +
        '//' +
        this.props.bucket +
        '.s3-' +
        AWS.config.region +
        '.amazonaws.com/' +
        enckey
      );
    }
  };

  renderObject = (file) => {
    const path = this.getPath(file);

    if (file.Prefix) {
      const handleClick = (e) => this.retrieveFolder(e, file.Prefix);
      const folderName = this.fullPathToFolder(path);

      return (
        <a href="#file" onClick={handleClick}>
          <FontAwesomeIcon icon={faFolder} /> {folderName}{' '}
        </a>
      );
    } else {
      const filePath = this.fileS3Path(file.Key);
      const fileName = this.fullPathToFileName(path);

      return (
        <a href={filePath} target="_blank">
          {fileName}{' '}
        </a>
      );
    }
  };

  getFolderPath = () => {
    return `${this.props.bucket}/${this.state.prefix}`;
  };

  breadCrumbClick = (e, savePrefix) => {
    e.preventDefault();

    this.setState(
      {
        prefix: savePrefix,
      },
      () => {
        this.fetchFiles();
      }
    );
  };

  topLevelBreadCrumbClick = (e) => {
    e.preventDefault();

    this.setState(
      {
        prefix: '',
      },
      () => {
        this.fetchFiles();
      }
    );
  };

  breadcrumbPrefix = (parts, part) => {
    const partIndex = parts.indexOf(part);

    let prefix = '';
    parts.forEach((part, index) => {
      // Skip prefix for the bucket if present
      if (index <= partIndex && !this.props.bucket.includes(part)) {
        prefix = prefix.concat(`${part}/`);
      }
    });
    return prefix;
  };

  displayPart = (part) => {
    const prefix = this.props.prefix.replace('/', '');

    return prefix === part ? 'Documents' : part;
  };

  folderToBreadcrumbs = () => {
    var parts = [this.props.bucket];

    if (this.state.prefix) {
      parts.push.apply(
        parts,
        this.state.prefix.endsWith('/')
          ? this.state.prefix.slice(0, -1).split('/')
          : this.state.prefix.split('/')
      );
    }

    const buildPrefix = parts.map((part, i) => {
      if (i !== 0) {
        if (i === parts.length - 1) {
          return (
            <li key={i} className="active">
              {this.displayPart(part)}
            </li>
          );
        } else {
          return (
            <li key={i}>
              <a
                href=""
                onClick={(e) => {
                  this.breadCrumbClick(e, this.breadcrumbPrefix(parts, part));
                }}
              >
                {this.displayPart(part)}
              </a>
            </li>
          );
        }
      }
      return false;
    });
    return buildPrefix;
  };

  updateFilesDisplayed = (scope) => (err, data) => {
    const { filesSortDirection } = this.state;
    if (err) {
      scope.stop = true;
    } else {
      var files = data.Contents;

      files = files.concat(data.CommonPrefixes);
      if (scope.params.Prefix) {
        // filter out folder if prefix
        files = files.filter((file) => file.Key !== scope.params.Prefix);
      }

      this.setState({ files }, () => {
        this.sortFilesColumns(filesSortDirection);
      });
    }
  };

  showRenameFolderModal = (event, prefix) => {
    event.preventDefault();
    const folderName = this.fullPathToFolder(prefix).replace('/', '');
    this.setState({
      showCreateFolderModal: true,
      currentFolderName: folderName,
      renameFolder: true,
    });
  };

  renameFolderButton = (file) => {
    if (file.Prefix && this.canUserPerformActions()) {
      return (
        <a
          href=""
          className="table-action-button"
          style={{ marginRight: '39px' }}
          onClick={(e) => this.showRenameFolderModal(e, file.Prefix)}
        >
          Rename
        </a>
      );
    }
  };

  moveObjectButton = (file) => {
    return (
      <a
        href=""
        className="table-action-button"
        onClick={(e) => this.showMoveFolderModalClick(e, file)}
      >
        Move
      </a>
    );
  };

  showMoveFolderModalClick = (e, file) => {
    e.preventDefault();
    this.setState({
      showMoveFolderModal: true,
      moveObjectSelected: file.Key || file.Prefix,
    });
  };

  handleMoveFolderModalClose = () => {
    this.setState({ showMoveFolderModal: false });
  };

  handleMoveFolderModalSubmit = () => {};

  showDownloadObjectsModalClick = (prefix) => {
    this.setState({ showDownloadObjectsModal: true });
  };

  showCreateFolderModalClick = () => {
    this.setState({
      showCreateFolderModal: true,
      renameFolder: false,
      currentFolderName: null,
    });
  };

  handleCreateFolderModalClose = () => {
    this.setState({
      showCreateFolderModal: false,
      renameFolder: false,
      currentFolderName: null,
    });
  };

  handleCreateFolderModalSubmit = (submitValues) => {
    const { currentProject, dispatch } = this.props;
    const { renameFolder } = this.state;
    const values = {
      folderName: submitValues.folderName,
      prefix: submitValues.prefix,
    };

    if (!renameFolder) {
      dispatch(
        createAdvancedDocumentsFolderRequest(currentProject.id, values)
      ).then((response) => {
        if (response.ok) {
          this.setState({ showCreateFolderModal: false });
          this.renderDocuments();
        }
      });
    } else {
      values.oldFolderName = submitValues.oldFolderName;
      values.prefix = submitValues.prefix;

      dispatch(
        renameAdvancedDocumentsFolderRequest(currentProject.id, values)
      ).then((response) => {
        if (response.ok) {
          this.handleCreateFolderModalClose();
          this.renderDocuments();
        }
      });
    }
  };

  handleUploadFilesModalSubmit = (documents) => {
    const { currentProject, dispatch } = this.props;
    const values = {
      ...this.state,
      documents: documents,
    };
    dispatch(uploadAdvancedDocumentsRequest(currentProject.id, values)).then(
      (response) => {
        if (response.ok) {
          this.setState({ showUploadFilesModal: false });
          this.renderDocuments();
        }
      }
    );
  };

  fetchFiles = () => {
    var params = {
      Bucket: this.props.bucket,
      Prefix: this.state.prefix,
      Delimiter: this.props.delimiter,
    };

    var scope = {
      Contents: [],
      CommonPrefixes: [],
      params: params,
      stop: false,
    };

    scope.cb = this.updateFilesDisplayed;
    return s3.makeUnauthenticatedRequest(
      'listObjectsV2',
      scope.params,
      this.updateFilesDisplayed(scope)
    );
  };

  createFolderTitle = () => {
    return this.state.renameFolder ? 'Rename Folder' : 'Create Folder';
  };

  showUploadFilesModalClick = () => {
    this.setState({ showUploadFilesModal: true });
  };

  handleUploadFilesModalClose = () => {
    this.setState({ showUploadFilesModal: false });
  };

  showDeleteFilesConfirmationClick = () => {
    this.setState({ showDeleteFilesConfirmation: true });
  };

  showEmailObjectsModalClick = () => {
    this.setState({ showEmailObjectsModal: true });
  };

  handleEmailObjectsModalClose = () => {
    this.setState({ showEmailObjectsModal: false });
  };

  canUserPerformActions = () => {
    const { currentUser } = this.props;
    return (
      usersUtil.isAdmin(currentUser) ||
      usersUtil.hasType(currentUser, TYPES.GENERAL_CONTRACTOR) ||
      usersUtil.hasType(currentUser, TYPES.ARCHITECT)
    );
  };

  onChangeActionButtons = (option) => {
    switch (option.value) {
      case 'download':
        if (!this.areObjectsSelected()) return;
        this.showDownloadObjectsModalClick();
        break;
      case 'upload':
        this.showUploadFilesModalClick();
        break;
      case 'delete':
        if (!this.areObjectsSelected()) return;
        this.showDeleteFilesConfirmationClick();
        break;
      case 'email':
        if (!this.areObjectsSelected()) return;
        this.showEmailObjectsModalClick();
        break;
      default:
        break;
    }
  };

  renderActionButtons = () => {
    const options = [
      { value: 'upload', label: 'Upload' },
      { value: 'download', label: 'Download' },
      { value: 'email', label: 'Email' },
      { value: 'delete', label: 'Delete' },
    ];
    if (this.canUserPerformActions()) {
      return (
        <div className="panel-actions">
          <button
            href=""
            className="button"
            onClick={this.showCreateFolderModalClick}
          >
            Create Folder
          </button>
          <Dropdown
            options={options}
            placeholder="..."
            value={null}
            onChange={(option) => this.onChangeActionButtons(option)}
          />
        </div>
      );
    }
  };

  renderCheckbox = (file) => {
    const value = file.Key ? file.Key : file.Prefix;
    const classname = file.Key ? 'file' : 'folder';

    return <input type="checkbox" className={classname} value={value} />;
  };

  allCheckboxes = () => {
    return document.querySelectorAll(
      "input[class='file'], input[class='folder']"
    );
  };

  selectAllCheckboxes = () => {
    const value = !this.state.selectAll;
    var checkboxes = this.allCheckboxes();

    checkboxes.forEach((checkbox) => {
      checkbox.checked = value ? 'checked' : '';
    });
    this.setState({ selectAll: value });
  };

  unselectAllCheckboxes = () => {
    var checkboxes = this.allCheckboxes();

    checkboxes.forEach((checkbox) => {
      checkbox.checked = '';
    });
    this.setState({ selectAll: false });
  };

  selectedFiles = () => {
    var selectedFiles = [];
    const checkboxes = document.querySelectorAll("input[class='file']");

    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) return selectedFiles.push(checkbox.value);
    });

    return selectedFiles;
  };

  selectedFolders = () => {
    var selectedFolders = [];
    const checkboxes = document.querySelectorAll("input[class='folder']");

    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) return selectedFolders.push(checkbox.value);
    });

    return selectedFolders;
  };

  areObjectsSelected = () => {
    return this.selectedFolders().length > 0 || this.selectedFiles().length > 0;
  };

  deleteSelectedObjects = () => {
    const { currentProject, dispatch } = this.props;
    const selectedFiles = this.selectedFiles();
    const selectedFolders = this.selectedFolders();
    const values = {
      ...this.state,
      documents: selectedFiles,
      folders: selectedFolders,
    };

    dispatch(deleteAdvancedDocumentsRequest(currentProject.id, values)).then(
      (response) => {
        if (response.ok) {
          this.renderDocuments();
          this.unselectAllCheckboxes();
        }
      }
    );
  };

  handleDeleteFilesConfirmation = (confirmed) => {
    this.setState({ showDeleteFilesConfirmation: false });
    confirmed && this.deleteSelectedObjects();
  };

  handleDownloadObjectModalClose = () => {
    this.setState({ showDownloadObjectsModal: false });
  };

  handleDownloadObjectsModalSubmit = (params) => {
    const { bucket, region, dispatch } = this.props;
    const { prefix } = this.state;
    const values = {
      bucket: bucket,
      region: region,
      recipients: params.recipients,
      subject: params.subject,
      message: params.message,
      selectedFolders: this.selectedFolders(),
      rootFolder: prefix,
      selectedFiles: this.selectedFiles(),
    };

    dispatch(downloadAdvancedDocumentsFolderRequest(values)).then(
      (response) => {
        if (response.ok) {
          this.handleDownloadObjectModalClose();
          this.handleEmailObjectsModalClose();
          this.renderDocuments();
          this.unselectAllCheckboxes();
        }
      }
    );
  };

  handleMoveFolderModalSubmit = (params) => {
    const { dispatch, currentProject } = this.props;

    dispatch(
      moveAdvancedDocumentsFolderRequest(currentProject.id, params)
    ).then((response) => {
      if (response.ok) {
        this.handleMoveFolderModalClose();
        this.renderDocuments();
      }
    });
  };

  sortTable = (table, col, reverse) => {
    var tb = table.tBodies[0], // use `<tbody>` to ignore `<thead>` and `<tfoot>` rows
      tr = Array.prototype.slice.call(tb.rows, 0), // put rows into array
      i;
    reverse = -(+reverse || -1);
    tr = tr.sort(function (a, b) {
      // sort rows
      return (
        reverse * // `-1 *` if want opposite order
        a.cells[col].textContent
          .trim() // using `.textContent.trim()` for test
          .localeCompare(b.cells[col].textContent.trim())
      );
    });
    for (i = 0; i < tr.length; ++i) tb.appendChild(tr[i]); // append each row in order
  };

  sortFilesColumns = (direction) => {
    const table = document.getElementById('advanced-documents-table-table');
    const ascending = direction !== 'ascending';

    this.setState({ filesSortDirection: direction });
    this.sortTable(table, 1, ascending);
  };

  emailObjectsModalMessage = () => {
    const { currentProject } = this.props;
    const { street_address_1, city, state } = currentProject.building.location;

    return `Please find the below link to download  documents \
for ${currentProject.name}, located at ${street_address_1}, ${city}, ${state}.\n\n\
If you have questions, please contact me via the in app chat or email.`.trim();
  };

  render() {
    const { currentProject, currentUser, bucket } = this.props;
    const {
      showCreateFolderModal,
      currentFolderName,
      showUploadFilesModal,
      prefix,
      showDeleteFilesConfirmation,
      showDownloadObjectsModal,
      showMoveFolderModal,
      moveObjectSelected,
      showEmailObjectsModal,
      filesSortDirection,
    } = this.state;

    return (
      <React.Fragment>
        <div id="advanced-documents-table">
          <div className="row">
            <div className="col-lg-12">
              <div className="panel">
                <div className="panel-heading clearfix">
                  <div className="row title-row">
                    <div className="btn-group col-md-10">
                      <ul id="breadcrumb" className="breadcrumb">
                        {this.folderToBreadcrumbs()}
                      </ul>
                    </div>
                  </div>
                  <div className="row">{this.renderActionButtons()}</div>
                </div>

                <div className="panel-body">
                  <table
                    className="table table-hover"
                    id="advanced-documents-table-table"
                  >
                    <thead>
                      <tr>
                        <th data-sort-method="none">
                          <input
                            type="checkbox"
                            onClick={this.selectAllCheckboxes}
                          />
                        </th>
                        <th data-sort-default>
                          <SimpleHeader
                            label="FILES"
                            filter={{
                              options: [
                                {
                                  id: 'ascending',
                                  label: 'Ascending',
                                },
                                {
                                  id: 'descending',
                                  label: 'Descending',
                                },
                              ],
                              selected: `${filesSortDirection}`,
                            }}
                            onFilterOptionSelect={this.sortFilesColumns}
                          />
                        </th>
                        <th data-sort-method="none">LAST MODIFIED</th>
                        <th data-sort-method="none">SIZE</th>
                        <th data-sort-method="none">ACTIONS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.files.map((file, index) => (
                        <tr key={index}>
                          <td>{this.renderCheckbox(file)}</td>
                          <td>{this.renderObject(file)}</td>
                          <td>
                            {file.LastModified
                              ? moment(file.LastModified)
                                  .local()
                                  .format('YYYY-MM-DD HH:mm:ss')
                              : ''}
                          </td>
                          <td>
                            {file.Size ? this.bytesToSize(file.Size) : ''}
                          </td>
                          <td>
                            {this.renameFolderButton(file)}
                            {this.moveObjectButton(file)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        {showCreateFolderModal && (
          <CreateFolderModal
            showModal={showCreateFolderModal}
            onSubmit={this.handleCreateFolderModalSubmit}
            onClose={this.handleCreateFolderModalClose}
            folderName={currentFolderName}
            prefix={prefix}
            title={this.createFolderTitle()}
          />
        )}
        {showUploadFilesModal && (
          <UploadFilesModal
            showModal={showUploadFilesModal}
            onSubmit={this.handleUploadFilesModalSubmit}
            onClose={this.handleUploadFilesModalClose}
            folderName={currentFolderName}
            prefix={prefix}
          />
        )}
        {showDeleteFilesConfirmation && (
          <ConfirmationModal
            show={showDeleteFilesConfirmation}
            message="Are you sure you want to delete these items and any sub items?"
            subMessage="You cannot undo this action."
            onHide={this.handleDeleteFilesConfirmation}
          />
        )}
        {showDownloadObjectsModal && (
          <DownloadObjectsModal
            showModal={showDownloadObjectsModal}
            onSubmit={this.handleDownloadObjectsModalSubmit}
            onClose={this.handleDownloadObjectModalClose}
            folders={() => this.selectedFolders()}
            projectId={currentProject.id}
            currentUser={currentUser}
            prefix={prefix}
            title="Download"
          />
        )}
        {showEmailObjectsModal && (
          <DownloadObjectsModal
            showModal={showEmailObjectsModal}
            onSubmit={this.handleDownloadObjectsModalSubmit}
            onClose={this.handleEmailObjectsModalClose}
            folders={() => this.selectedFolders()}
            projectId={currentProject.id}
            currentUser={currentUser}
            prefix={prefix}
            title="Email"
            message={this.emailObjectsModalMessage()}
          />
        )}
        {showMoveFolderModal && (
          <MoveFolderOrFileModal
            showModal={showMoveFolderModal}
            onSubmit={this.handleMoveFolderModalSubmit}
            onClose={this.handleMoveFolderModalClose}
            bucket={bucket}
            prefix={prefix}
            selectedObject={moveObjectSelected}
          />
        )}
      </React.Fragment>
    );
  }
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
    currentProject: getCurrentProject(state),
  };
})(AdvancedDocumentsTable);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-documentation/AdvancedDocumentsTable.js